<app-modal>
  <form (ngSubmit)="onSubmit()"
        [formGroup]="formGroup">

    <h2>Flag {{data.entity | fullName}} for follow-up</h2>
    <p><strong>Note:</strong> Adding a new flag for {{ data.entity | fullName }} will complete existing follow-up
      flags.</p>


    <mat-form-field class="w-100 mb-0100">
      <mat-label>Note (required)</mat-label>
      <textarea [formControl]="noteControl"
                matInput></textarea>
    </mat-form-field>

    <mat-form-field class="col__">
      <mat-label>Assign to user (leave blank to assign to yourself)</mat-label>
      <input type="text"
             placeholder="Search users"
             matInput
             [formControl]="searchControl"
             [matAutocomplete]="auto">
      <mat-autocomplete autoActiveFirstOption
                        #auto="matAutocomplete"
                        [displayWith]="userDisplayFn">
        <mat-option *ngFor="let option of filteredResults$ | async"
                    [value]="option">
          {{ option.firstName }} {{option.lastName}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="col__">
      <mat-label>Due Date (leave blank for none)</mat-label>
      <input matInput
             [matDatepicker]="dueDatePicker"
             autocomplete="off"
             [formControl]="dueDateControl"
             name="dueDate">
      <mat-datepicker-toggle matSuffix
                             [for]="dueDatePicker">
        <mat-icon fontSet="far"
                  fontIcon="fa-calendar"
                  matDatepickerToggleIcon></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #dueDatePicker></mat-datepicker>
    </mat-form-field>

    <button class="btn"
            type="submit"
            [disabled]="noteControl.invalid">
      Save Flag
    </button>
  </form>
</app-modal>
